var _path, _path2, _path3, _path4, _path5, _circle, _circle2, _circle3, _circle4, _circle5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorFastFood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m36.903,29.521l.327,2.484c.343,2.599-1.68,4.906-4.302,4.906H9.763c-2.622,0-4.645-2.307-4.302-4.906l.331-2.514"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m12.932,29.718l4.064,3.485c.98.841,2.365,1.021,3.527.458l8.389-4.058"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m37.496,23.943l.656,1.66c.906,2.29-.964,4.717-3.409,4.426l-3.568-.425c-6.759-.804-13.59-.789-20.346.045l-2.857.353c-2.45.302-4.331-2.128-3.423-4.424l.735-1.858"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m36.873,18.707l1.95,3.631c.511.951-.429,2.028-1.44,1.65l-2.33-.869c-1.541-.575-3.268-.32-4.578.674l-.731.555c-1.69,1.284-4.023,1.304-5.735.051l-.12-.088c-1.714-1.255-4.049-1.233-5.739.054h0c-1.676,1.276-3.989,1.309-5.701.081l-1.047-.751c-1.305-.936-2.992-1.157-4.494-.589l-2.275.861c-1.012.383-1.957-.695-1.445-1.648l1.94-3.611"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m16.158,5.089h9.685c7.35,0,13.317,5.967,13.317,13.317H2.841c0-7.35,5.967-13.317,13.317-13.317Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.281,
    cy: 11.174,
    r: 0.637
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.005,
    cy: 9.116,
    r: 0.637
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.698,
    cy: 11.174,
    r: 0.637
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.869,
    cy: 13.923,
    r: 0.637
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.885,
    cy: 13.923,
    r: 0.637
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorFastFood);
export default __webpack_public_path__ + "static/media/indoor-fast_food.c8e9e689e3f171eb64741b6747972df3.svg";
export { ForwardRef as ReactComponent };